import { render } from "./CreateLessonScreen.vue?vue&type=template&id=741d684d"
import script from "./CreateLessonScreen.vue?vue&type=script&lang=ts"
export * from "./CreateLessonScreen.vue?vue&type=script&lang=ts"

import "./CreateLessonScreen.vue?vue&type=style&index=0&id=741d684d&lang=scss"
script.render = render

export default script